webpackJsonp([75877879751207],{

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DISQUS_CONFIG = ['shortname', 'identifier', 'title', 'url', 'category_id', 'onNewComment', 'language'];
	var __disqusAdded = false;
	
	function copyProps(context, props) {
	    var onNewComment = props.onNewComment,
	        language = props.language,
	        rest = _objectWithoutProperties(props, ['onNewComment', 'language']);
	
	    for (var prop in rest) {
	        context.page[prop] = rest[prop];
	    }
	
	    // Setting the language - if none is provided, the default one is used
	    context.language = language;
	
	    if (onNewComment) {
	        context.callbacks = {
	            onNewComment: [onNewComment]
	        };
	    }
	}
	
	var DisqusThread = function (_React$Component) {
	    _inherits(DisqusThread, _React$Component);
	
	    function DisqusThread() {
	        _classCallCheck(this, DisqusThread);
	
	        return _possibleConstructorReturn(this, (DisqusThread.__proto__ || Object.getPrototypeOf(DisqusThread)).apply(this, arguments));
	    }
	
	    _createClass(DisqusThread, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            this.loadDisqus();
	        }
	    }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	            return nextProps.identifier !== this.props.identifier;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            var props = Object.keys(this.props).reduce(function (memo, key) {
	                return DISQUS_CONFIG.some(function (config) {
	                    return config === key;
	                }) ? memo : _extends({}, memo, _defineProperty({}, key, _this2.props[key]));
	            }, {});
	
	            return _react2.default.createElement(
	                'div',
	                props,
	                _react2.default.createElement('div', { id: 'disqus_thread' })
	            );
	        }
	    }, {
	        key: 'addDisqusScript',
	        value: function addDisqusScript() {
	            if (__disqusAdded) {
	                return;
	            }
	
	            var child = this.disqus = document.createElement('script');
	            var parent = document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0];
	
	            child.async = true;
	            child.type = 'text/javascript';
	            child.src = '//' + this.props.shortname + '.disqus.com/embed.js';
	
	            parent.appendChild(child);
	            __disqusAdded = true;
	        }
	    }, {
	        key: 'loadDisqus',
	        value: function loadDisqus() {
	            var _this3 = this;
	
	            var props = {};
	
	            // Extract Disqus props that were supplied to this component
	            DISQUS_CONFIG.forEach(function (prop) {
	                // prop "shortname" is only necessary for loading the script, not for the config itself
	                if (prop !== 'shortname' && !!_this3.props[prop]) {
	                    props[prop] = _this3.props[prop];
	                }
	            });
	
	            // If Disqus has already been added, reset it
	            if (typeof DISQUS !== 'undefined') {
	                DISQUS.reset({
	                    reload: true,
	                    config: function config() {
	                        copyProps(this, props);
	
	                        // Disqus needs hashbang URL, see https://help.disqus.com/customer/portal/articles/472107
	                        this.page.url = this.page.url.replace(/#/, '') + '#!newthread';
	                    }
	                });
	            } else {
	                // Otherwise add Disqus to the page
	                window.disqus_config = function () {
	                    copyProps(this, props);
	                };
	                this.addDisqusScript();
	            }
	        }
	    }]);
	
	    return DisqusThread;
	}(_react2.default.Component);
	
	DisqusThread.displayName = 'DisqusThread';
	
	DisqusThread.propTypes = {
	    id: _propTypes2.default.string,
	
	    /**
	     * `shortname` tells the Disqus service your forum's shortname,
	     * which is the unique identifier for your website as registered
	     * on Disqus. If undefined , the Disqus embed will not load.
	     */
	    shortname: _propTypes2.default.string.isRequired,
	
	    /**
	     * `identifier` tells the Disqus service how to identify the
	     * current page. When the Disqus embed is loaded, the identifier
	     * is used to look up the correct thread. If disqus_identifier
	     * is undefined, the page's URL will be used. The URL can be
	     * unreliable, such as when renaming an article slug or changing
	     * domains, so we recommend using your own unique way of
	     * identifying a thread.
	     */
	    identifier: _propTypes2.default.string,
	
	    /**
	     * `title` tells the Disqus service the title of the current page.
	     * This is used when creating the thread on Disqus for the first time.
	     * If undefined, Disqus will use the <title> attribute of the page.
	     * If that attribute could not be used, Disqus will use the URL of the page.
	     */
	    title: _propTypes2.default.string,
	
	    /**
	     * `url` tells the Disqus service the URL of the current page.
	     * If undefined, Disqus will take the window.location.href.
	     * This URL is used to look up or create a thread if disqus_identifier
	     * is undefined. In addition, this URL is always saved when a thread is
	     * being created so that Disqus knows what page a thread belongs to.
	     */
	    url: _propTypes2.default.string,
	
	    /**
	     * `category_id` tells the Disqus service the category to be used for
	     * the current page. This is used when creating the thread on Disqus
	     * for the first time.
	     */
	    category_id: _propTypes2.default.string,
	
	    /**
	     * `onNewComment` function accepts one parameter `comment` which is a
	     * JavaScript object with comment `id` and `text`. This allows you to track
	     * user comments and replies and run a script after a comment is posted.
	     */
	    onNewComment: _propTypes2.default.func,
	
	    /**
	     * `language` tells the Disqus service which language should be used.
	     * Please refer to https://www.transifex.com/disqus/disqus/ on which languages can be used
	     * If undefined, English is used as default one
	     */
	    language: _propTypes2.default.string
	};
	
	DisqusThread.defaultProps = {
	    url: typeof window === 'undefined' ? null : window.location.href
	};
	
	exports.default = DisqusThread;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(97);

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _format = __webpack_require__(115);
	
	var _format2 = _interopRequireDefault(_format);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// text-shadow: 0px 0px 0 ${props => props.theme.colors.warm.dark},
	// 2px 0px 0 ${props => props.theme.colors.cool.dark},
	// 0px 2px 0 ${props => props.theme.colors.cool.dark},
	// 2px 2px 0 ${props => props.theme.colors.cool.dark};
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e12rvry70'
	})('padding-top:2rem;padding-bottom:2rem;img,tr,.gatsby-resp-iframe-wrapper{box-shadow:0px 2px 20px rgba(0,0,0,0.7);margin-bottom:1rem;}.gatsby-highlight{margin-bottom:2rem;}ul{list-style:none;margin-left:0;padding-left:0em;text-indent:-1.8rem;}p,li{list-style:none;letter-spacing:-0.003em;--baseline-multiplier:0.179;--x-height-multiplier:0.35;font-size:1.35rem;line-height:1.6;code{padding:0.2rem 0.5rem;margin:0.5rem 0;}}a{color:', function (props) {
	  return props.theme.set.light.p;
	}, ';border-bottom:3px solid ', function (props) {
	  return props.theme.set.light.a;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow.text.small;
	}, ';font-weight:600;transition:', function (props) {
	  return props.theme.transitions.main.transition;
	}, ';&:focus,&:hover{color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';background-color:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';}}h1,h2,h3,h4,h5,h6{a{color:', function (props) {
	  return props.theme.set.light.a;
	}, ';box-shadow:rgba(black,0);border-bottom:0;&:hover,&:focus{color:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';background:none;}}}p,h1,h2,h3,h4,h5,h6,Text,li,ul{max-width:55rem;margin-left:auto;margin-right:auto;padding:0 2rem;}.imgWrapDiv{overflow:hidden;box-shadow:0px 2px 20px rgba(0,0,0,0.7);}table{margin-top:1.5rem;max-width:1920px;margin-left:auto;margin-right:auto;box-shadow:0px 2px 20px rgba(0,0,0,0.7);}img,.gatsby-remark-image,.gatsby-resp-image-wrapper,gatsby-remark-image{}.gatsby-resp-image-wrapper{box-shadow:0px 2px 20px rgba(0,0,0,0.7);margin-bottom:1rem;transition:', function (props) {
	  return props.theme.transitions.boom;
	}, ';@media only screen and (orientation:portrait) and (max-device-aspect-ratio:1/1){left:-25%;right:25%;width:175%;position:relative;:focus,:hover{width:100%;left:0;right:0;}}@media (min-width:1921px){width:100%;}}/*and (max-height:max-device-width) \n   and (max-width:max-height)\n  */\n  tr{border-radius:', function (props) {
	  return props.theme.borderRadius.round;
	}, ';}td,th{text-align:center;border-radius:', function (props) {
	  return props.theme.borderRadius.round;
	}, ';}table{width:90%;margin-left:auto;margin-right:auto;background-color:transparent;}h1{margin-top:2rem;margin-bottom:0.25rem;/* \n    margin-left:-0.06125rem;*/\n    /*\n    margin-left:-0.030625rem;*/\n\n    color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';}h3{position:relative;margin-top:0.5rem;margin-bottom:0.25rem;}h6{font-size:1.5rem;margin-bottom:-0.5rem;margin-top:-1.5rem;color:', function (props) {
	  return props.theme.set.light.h1;
	}, ';text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ';}.subH{a{bottom-margin:-40rem;color:', function (props) {
	  return props.theme.set.light.a;
	}, ';box-shadow:rgba(black,0);border-bottom:0;&:hover,&:focus{color:', function (props) {
	  return props.theme.set.light.highlight;
	}, ';background:none;}}}.gifDiv{width:100%;img{width:100%;}@media (min-width:1000px){margin-bottom:2.5rem;}}.gatsby-highlight{div{max-width:200px;padding-top:2rem;padding-bottom:2rem;}}code{position:relative;margin-bottom:5rem;}.language-javascript{margin:1rem auto;max-width:1920px;background-color:', function (props) {
	  return props.theme.colors.pure.ink;
	}, ';font-size:1.1225rem;font-size:1rem;font-family:\'Source Code Pro\',\'Courier New\',Courier,monospace;code{}}.language-text{font-family:\'Source Code Pro\',\'Courier New\',Courier,monospace;background-color:rgba(0,0,0,0);color:', function (props) {
	  return props.theme.set.light.p;
	}, ';code{}}/*\n  .media4x3 > iframe,div{max-width:100%;margin-left:auto;margin-right:auto;margin-bottom:2rem;div{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}@media(min-width:1174px){div{box-shadow:0px 2px 20px rgba(0,0,0,0);top-margin:2rem;}iframe{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}max-width:1172px;max-height:880px;margin-left:auto;margin-right:auto;}}.media4x3 > .gatsby-resp-iframe-wrapper,div{margin-top:1.5rem;max-width:100%;margin-left:auto;margin-right:auto;iframe{background-color:black;}@media(min-width:1174px){margin-top:0.5rem;max-width:1274px;max-height:880px;width:100%;height:100%;top:-1.08rem;margin-bottom:3rem;}}.media4x3{margin-left:auto;margin-right:auto;@media(min-width:1174px){position:absolute;top:1.65rem;left:1rem;}}.media16x9 > iframe,div{max-width:100%;margin-left:auto;margin-right:auto;margin-bottom:2rem;background-color:transparent;box-shadow:0px 2px 20px rgba(0,0,0,0);div{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}@media(min-width:1921px){div{box-shadow:0px 2px 20px rgba(0,0,0,0);top-margin:20rem;}iframe{box-shadow:0px 2px 20px rgba(0,0,0,0.7);}max-width:1920px;max-height:1080px;margin-left:3rem;margin-right:3rem;}}.media16x9 > .gatsby-resp-iframe-wrapper,div{margin-top:2.5rem;max-width:100%;max-height:100%;background-color:transparent;margin-left:auto;margin-right:auto;iframe{background-color:black;}@media(min-width:1921px){margin-top:0.5rem;max-width:1920px;max-height:1080px;width:100%;height:100%;top:-1.08rem;margin-bottom:3rem;}*/\n  .media4x3{margin-left:auto;margin-right:auto;position:absolute;background-color:black;@media (min-width:1174px){min-width:1174px;min-height:880px;}}.media4x3 > .gatsby-resp-iframe-wrapper,div{max-width:1174px;max-height:880px;margin-left:auto;margin-right:auto;margin-top:1.5rem;}.media16x9{background-color:black;margin-left:auto;margin-right:auto;position:relative;top:-5rem;@media (min-width:1921px){min-width:1920px;min-height:1080px;}}.media16x9 > iframe,img{max-width:1920px;margin-left:auto;margin-right:auto;}.fatLink{text-shadow:', function (props) {
	  return props.theme.set.light.shadow.pop;
	}, ';}.fatArrowLink{top:0.35rem;position:relative;font-size:2.75rem;font-weight:bolder;}');
	// import { toColorString } from 'polished';
	// import theme from '../../config/theme';
	
	var Content = function Content(_ref) {
	  var input = _ref.input;
	
	  // const updated = format(new Date(document.lastModified), 'MMM.DD.YYYY');
	  if (typeof document !== 'undefined') {
	    input = input.replace(/id="updated">(.*?)</gi, 'id="updated">' + (0, _format2.default)(new Date(document.lastModified), 'MMM.DD.YYYY') + '<');
	  }
	  return _react2.default.createElement(Wrapper, { dangerouslySetInnerHTML: { __html: input } });
	};
	exports.default = Content;
	
	
	Content.propTypes = {
	  input: _propTypes2.default.any.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _reactDisqusComments = __webpack_require__(38);
	
	var _reactDisqusComments2 = _interopRequireDefault(_reactDisqusComments);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StyledContainer = /*#__PURE__*/(0, _reactEmotion2.default)(_Container2.default, {
	  target: 'ekyodkq0'
	})('max-width:55rem;margin-bottom:4rem;padding-left:2rem;padding-right:2rem;');
	
	var DisqusContainer = function DisqusContainer(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    StyledContainer,
	    null,
	    children
	  );
	};
	
	exports.default = DisqusContainer;
	module.exports = exports['default'];

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CenterDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'exatee20'
	})('position:absolute;z-index:9;width:100%;height:100%;background-color:', function (props) {
	  return props.theme.colors.night.tint;
	}, ';');
	
	var FxTint = function FxTint(props) {
	  var children = props.children;
	
	  return _react2.default.createElement(
	    CenterDiv,
	    { style: { backgroundColor: '' + props.color, opacity: '' + props.opacity } },
	    children
	  );
	};
	exports.default = FxTint;
	
	
	FxTint.propTypes = {
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number
	};
	
	FxTint.defaultProps = {
	  color: '',
	  opacity: 0.25
	};
	module.exports = exports['default'];

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SEO = function SEO(props) {
	  var postNode = props.postNode,
	      postPath = props.postPath,
	      postSEO = props.postSEO;
	
	  var title = void 0;
	  var description = void 0;
	  var image = void 0;
	  var postURL = void 0;
	  if (postSEO) {
	    var postMeta = postNode.frontmatter;
	    title = postMeta.title; // eslint-disable-line prefer-destructuring
	    description = postNode.excerpt;
	    image = postMeta.cover.childImageSharp.resize.src;
	    postURL = _website2.default.siteUrl + _website2.default.pathPrefix + postPath;
	  } else {
	    title = _website2.default.siteTitle;
	    description = _website2.default.siteDescription;
	    image = _website2.default.siteBanner;
	  }
	  var realPrefix = _website2.default.pathPrefix === "/" ? "" : _website2.default.pathPrefix;
	  image = _website2.default.siteUrl + realPrefix + image;
	  var newsURL = _website2.default.siteUrl + _website2.default.pathPrefix;
	  var schemaOrgJSONLD = [{
	    "@context": "http://schema.org",
	    "@type": "WebSite",
	    url: newsURL,
	    name: title,
	    alternateName: _website2.default.siteTitleAlt ? _website2.default.siteTitleAlt : ""
	  }];
	  if (postSEO) {
	    schemaOrgJSONLD.push([{
	      "@context": "http://schema.org",
	      "@type": "BreadcrumbList",
	      itemListElement: [{
	        "@type": "ListItem",
	        position: 1,
	        item: {
	          "@id": postURL,
	          name: title,
	          image: image
	        }
	      }]
	    }, {
	      "@context": "http://schema.org",
	      "@type": "newsPosting",
	      url: newsURL,
	      name: title,
	      alternateName: _website2.default.siteTitleAlt,
	      headline: title,
	      image: {
	        "@type": "ImageObject",
	        url: image
	      },
	      description: description
	    }]);
	  }
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    null,
	    _react2.default.createElement("html", { lang: "en" }),
	    _react2.default.createElement(
	      "title",
	      null,
	      title
	    ),
	    _react2.default.createElement("meta", { name: "description", content: description }),
	    _react2.default.createElement("meta", { name: "image", content: image }),
	    _react2.default.createElement("meta", { charSet: "utf-8" }),
	    _react2.default.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge,chrome=1" }),
	    _react2.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1" }),
	    _react2.default.createElement("link", {
	      rel: "apple-touch-icon",
	      sizes: "180x180",
	      href: "/favicons/apple-touch-icon.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "icon",
	      type: "image/png",
	      sizes: "32x32",
	      href: "/favicons/favicon-32x32.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "icon",
	      type: "image/png",
	      sizes: "16x16",
	      href: "/favicons/favicon-16x16.png"
	    }),
	    _react2.default.createElement("link", {
	      rel: "mask-icon",
	      href: "/favicons/safari-pinned-tab.svg",
	      color: "#343849"
	    }),
	    _react2.default.createElement("meta", { name: "apple-mobile-web-app-title", content: "Sondro" }),
	    _react2.default.createElement("meta", { name: "application-name", content: "Sondro" }),
	    _react2.default.createElement("meta", { name: "msapplication-TileColor", content: "#3498db" }),
	    _react2.default.createElement(
	      "script",
	      { type: "application/ld+json" },
	      JSON.stringify(schemaOrgJSONLD)
	    ),
	    _react2.default.createElement("meta", { property: "og:locale", content: "us_EN" }),
	    _react2.default.createElement("meta", { property: "og:site_name", content: _website2.default.facebook }),
	    _react2.default.createElement("meta", { property: "og:url", content: postSEO ? postURL : newsURL }),
	    postSEO ? _react2.default.createElement("meta", { property: "og:type", content: "article" }) : null,
	    _react2.default.createElement("meta", { property: "og:title", content: title }),
	    _react2.default.createElement("meta", { property: "og:description", content: description }),
	    _react2.default.createElement("meta", { property: "og:image", content: image }),
	    _react2.default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
	    _react2.default.createElement("meta", { name: "twitter:creator", content: _website2.default.twitter }),
	    _react2.default.createElement("meta", { name: "twitter:title", content: title }),
	    _react2.default.createElement("meta", { name: "twitter:description", content: description }),
	    _react2.default.createElement("meta", { name: "twitter:image", content: image })
	  );
	};
	
	exports.default = SEO;
	
	
	SEO.propTypes = {
	  postNode: _propTypes2.default.object,
	  postPath: _propTypes2.default.string,
	  postSEO: _propTypes2.default.bool
	};
	module.exports = exports["default"];

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FxVignette = __webpack_require__(22);
	
	var _FxVignette2 = _interopRequireDefault(_FxVignette);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Row = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr40'
	})('display:flex;flex-wrap:wrap;justify-content:space-between;margin-top:2rem;margin-bottom:1rem;padding-right:2rem;padding-left:2rem;');
	
	// import { theme } from '../../config/theme';
	
	
	var ImageOverlay = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr41'
	})('border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';position:absolute;top:-1px;right:-1px;left:-1px;bottom:-1px;z-index:2;opacity:0.1;transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';background-image:linear-gradient(\n    30deg,', function (props) {
	  return props.theme.colors.cool.light;
	}, ' 0%,', function (props) {
	  return props.theme.colors.cool.dark;
	}, ' 100%\n  );');
	
	var Wrap = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr42'
	})('position:relative;transform:skewY(-3deg);box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.main;
	}, ';transition:', function (props) {
	  return props.theme.transitions.boom.transition;
	}, ';border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';height:15rem;');
	
	var StyledDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr43'
	})('position:absolute;top:0;left:0;right:0;bottom:0;display:block;/*\n  justify-content:center;align-items:center;*/\n  padding:1rem;z-index:9;');
	
	var Image = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr44'
	})('position:absolute;overflow:hidden;top:-1px;right:-1px;left:-1px;bottom:-1px;border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';img{border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';object-fit:cover;width:100%;height:100%;}');
	
	var Title = /*#__PURE__*/(0, _reactEmotion2.default)('h4', {
	  target: 'e1t85hr45'
	})('color:', function (props) {
	  return props.theme.colors.pure.bright;
	}, ';margin-bottom:0;font-family:', function (props) {
	  return props.theme.fontFamily.button;
	}, ';font-size:1.75rem;text-shadow:', function (props) {
	  return props.theme.set.light.shadow._3d;
	}, ';top:11rem;left:-1.5rem;position:relative;');
	
	var Grid = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr46'
	})('display:grid;grid-template-columns:repeat(2,1fr);grid-row-gap:2rem;grid-column-gap:2rem;height:21rem;justify-content:center;align-items:center;@media (max-width:1000px){grid-template-columns:1fr;}');
	
	var Excerpt = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr47'
	})('position:absolute;display:block;z-index:99;top:0px;width:100%\n  height:100%;opacity:0;visibility:hidden;padding:10% 1rem 1rem 1rem;color:', function (props) {
	  return props.theme.colors.pure.bright;
	});
	
	var Clicker = /*#__PURE__*/(0, _reactEmotion2.default)(_gatsbyLink2.default, {
	  target: 'e1t85hr48'
	})('font-size:1.25rem;position:relative;display:block;width:100%;height:17rem;&:focus,&:hover{', Wrap, '{box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.hover;
	}, ';transform:translateY(-12px) skewY(-1deg);}', ImageOverlay, '{opacity:0.9;}', StyledDiv, '{/*\n      background:linear-gradient(\n        to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 35%,rgba(0,0,0,0.5) 50%,rgba(0,0,0,0.4) 65%,rgba(0,0,0,0) 100%\n      );border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';*/}', Excerpt, '{visibility:visible;opacity:1;transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';', Excerpt, '{}}}@media (max-width:800px){flex-basis:100%;max-width:100%;width:100%;margin-bottom:2rem;font-size:1.35rem;', Excerpt, '{top:-8%;}}@media (min-width:800px){font-size:1.1225rem;', Excerpt, '{top:-3%;}}@media (min-width:1200px){font-size:1.35rem;', Excerpt, '{top:-1.25rem;}}');
	
	var SpanCss = /*#__PURE__*/(0, _reactEmotion2.default)('span', {
	  target: 'e1t85hr49'
	})('position:relative;display:block;width:49%;height:17rem;@media (max-width:800px){flex-basis:100%;max-width:100%;width:100%;margin-bottom:2rem;}');
	
	var TapDiv = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1t85hr410'
	})('background-color:rgba(100,0,0,0.5);position:relative;z-index:999;top:-0rem;left:-2rem;width:150%;height:200%;opacity:0;@media (max-width:600px){z-index:999;display:inline;}');
	var TapRadio = /*#__PURE__*/(0, _reactEmotion2.default)('input', {
	  target: 'e1t85hr411'
	})('position:absolute;z-index:-99;top:-0.25rem;width:100%;height:100%;opacity:0;display:none;@media (max-width:600px){z-index:9999;display:inline;&:checked + label{display:none;}&:checked{display:none;}&:unchecked{', TapDiv, '{display:inline;}}&:hover ~ ', Clicker, ',&:checked ~ ', Clicker, ',', Clicker, ':focus{', Wrap, '{box-shadow:', function (props) {
	  return props.theme.set.light.shadow.feature.small.hover;
	}, ';transform:translateY(-12px) skewY(1deg);}', ImageOverlay, '{opacity:0.9;}', StyledDiv, '{/*\n      background:linear-gradient(\n        to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,0.4) 35%,rgba(0,0,0,0.5) 50%,rgba(0,0,0,0.4) 65%,rgba(0,0,0,0) 100%\n      );border-radius:', function (props) {
	  return props.theme.borderRadius.main;
	}, ';transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';*/}', Excerpt, '{visibility:visible;opacity:1;transition:opacity ', function (props) {
	  return props.theme.transitions.main.duration;
	}, ';}}');
	
	var Suggestions = function Suggestions(_ref) {
	  var left = _ref.left,
	      right = _ref.right;
	
	  //alert(JSON.stringify(left));
	  //src={right.frontmatter.cover.childImageSharp.resize.src}
	  var thumbSize = 600;
	
	  return _react2.default.createElement(
	    Row,
	    null,
	    left && _react2.default.createElement(
	      SpanCss,
	      null,
	      _react2.default.createElement(TapRadio, { type: 'radio', name: 'r' }),
	      _react2.default.createElement(
	        'label',
	        { style: { position: 'absolute' } },
	        _react2.default.createElement(TapDiv, { className: 'TapDiv', id: 'TapDiv', name: 'r' })
	      ),
	      _react2.default.createElement(
	        Clicker,
	        { to: left.fields.slug },
	        _react2.default.createElement(
	          Wrap,
	          null,
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement(
	              Excerpt,
	              null,
	              left.excerpt
	            ),
	            _react2.default.createElement(_FxVignette2.default, null),
	            _react2.default.createElement('img', { src: left.frontmatter.cover.childImageSharp.resize.src, alt: left.frontmatter.title })
	          ),
	          _react2.default.createElement(
	            StyledDiv,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              left.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(ImageOverlay, null)
	        )
	      )
	    ),
	    right && _react2.default.createElement(
	      SpanCss,
	      null,
	      _react2.default.createElement(TapRadio, { type: 'radio', name: 'r' }),
	      _react2.default.createElement(
	        'label',
	        { style: { position: 'absolute' } },
	        _react2.default.createElement(TapDiv, { className: 'TapDiv', id: 'TapDiv', name: 'r' })
	      ),
	      _react2.default.createElement(
	        Clicker,
	        { to: right.fields.slug },
	        _react2.default.createElement(
	          Wrap,
	          null,
	          _react2.default.createElement(
	            Image,
	            null,
	            _react2.default.createElement(
	              Excerpt,
	              null,
	              right.excerpt
	            ),
	            _react2.default.createElement(_FxVignette2.default, null),
	            _react2.default.createElement('img', { src: right.frontmatter.cover.childImageSharp.resize.src, alt: right.frontmatter.title })
	          ),
	          _react2.default.createElement(
	            StyledDiv,
	            null,
	            _react2.default.createElement(
	              Title,
	              null,
	              right.frontmatter.title
	            )
	          ),
	          _react2.default.createElement(ImageOverlay, null)
	        )
	      )
	    )
	  );
	};
	
	// const Suggestions = ({ left, right }) => {
	//   return (
	//     <Grid>
	//       <Clicker to={left.fields.slug}>
	//         <Wrap>
	//           <Image>
	//             <img
	//               src={left.frontmatter.cover.childImageSharp.resize.src}
	//               alt={left.frontmatter.title}
	//             />
	//           </Image>
	//           <StyledDiv>
	//             <Title>{left.frontmatter.title}</Title>
	//           </StyledDiv>
	//           <ImageOverlay />
	//         </Wrap>
	//       </Clicker>
	//       <Clicker to={right.fields.slug}>
	//         <Wrap>
	//           <Image>
	//             <img
	//               src={right.frontmatter.cover.childImageSharp.resize.src}
	//               alt={right.frontmatter.title}
	//             />
	//           </Image>
	//           <StyledDiv>
	//             <Title>{right.frontmatter.title}</Title>
	//           </StyledDiv>
	//           <ImageOverlay />
	//         </Wrap>
	//       </Clicker>
	//     </Grid>
	//   );
	// };
	
	exports.default = Suggestions;
	
	
	Suggestions.propTypes = {
	  left: _propTypes2.default.any.isRequired,
	  right: _propTypes2.default.any.isRequired
	};
	module.exports = exports['default'];

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _Wave = __webpack_require__(78);
	
	var _Wave2 = _interopRequireDefault(_Wave);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Wrapper = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'ejdppqq0'
	})('z-index:9;width:100%;top:8.5rem;position:absolute;@media (max-width:899px){top:4.6rem;}@media (max-width:599px){height:4.5rem;top:1.4rem;}@media (max-width:450px){height:4.5rem;top:2.38rem;}/*  \n  @media (max-width:', function (props) {
	  return props.theme.breakpoints.m;
	}, '){height:5rem;top:1.75rem;}@media (max-width:899px){position:relative;height:4.5rem;}@media (max-width:599px){height:4.5rem;top:5rem;}@media (max-width:450px){height:4.5rem;top:7.2rem;}*/');
	
	var WaveNews = function WaveNews(_ref) {
	  var orientation = _ref.orientation;
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_Wave2.default, { orientation: orientation })
	  );
	};
	
	exports.default = WaveNews;
	
	
	WaveNews.propTypes = {
	  orientation: _propTypes2.default.oneOf(['top', 'bottom'])
	};
	
	WaveNews.defaultProps = {
	  orientation: 'bottom'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _emotion = __webpack_require__(24);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ZoomPan = /*#__PURE__*/(0, _reactEmotion.keyframes)('0%{animation-timing-function:ease-in;}25%{animation-timing-function:ease-out;transform:scale(1.05);transform-origin:16% 84%;translate(1.25rem,0.9375);}50%{animation-timing-function:ease-in;transform:scale(1.125);transform-origin:16% 84%;translate(1.25rem,0.9375);}to{animation-timing-function:ease-out;transform:scale(1);translate(1.25rem,0.9375);}');
	
	var ZoomPanWrapStyle = /*#__PURE__*/(0, _reactEmotion2.default)('div', {
	  target: 'e1psy550'
	})('height:600px;position:relative;overflow:hidden;.gatsby-image-wrapper{z-index:0;height:600px;img{animation:', ZoomPan, ' 30s 2;animation-delay:1400ms;}}@media (max-width:', function (props) {
	  return props.theme.breakpoints.m;
	}, '){height:500px;.gatsby-image-wrapper{height:500px;}}@media (max-width:', function (props) {
	  return props.theme.breakpoints.s;
	}, '){height:400px;.gatsby-image-wrapper{height:400px;}}');
	
	var ZoomPanWrap = function ZoomPanWrap(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    ZoomPanWrapStyle,
	    null,
	    children
	  );
	};
	
	exports.default = ZoomPanWrap;
	
	
	ZoomPanWrap.propTypes = {
	  children: _propTypes2.default.node
	};
	
	/*
	ZoomPan.propTypes = {
	  children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired
	};
	*/

	module.exports = exports['default'];

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _path = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Trophy = function Trophy() {
	  return _react2.default.createElement(
	    'svg',
	    {
	      preserveAspectRatio: 'xMidYMid meet',
	      viewBox: '0 0 580 528',
	      style: { position: 'relative', left: '0.25rem', top: '0.1rem' }
	    },
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('path', { d: 'M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z' })
	    )
	  );
	};
	
	exports.default = Trophy;
	
	/*
	      paddingTop: '0.039rem',
	    viewBox="0 0 580 528"
	    style={{
	      position: 'relative',
	      left: '0.25rem',
	      top: '0.056rem',
	      marginTop: '-0.015',
	      paddingLeft: '0.2rem',
	    }}
	  viewBox="-5 -8 584 528"
	    style={{ position: 'relative', left: '0.07rem', top: '0.056rem', marginLeft: '0rem' }}
	    viewBox="0 0 580 528"
	    style={{ position: 'relative', left: '0.25rem', top: '0.1rem', marginLeft: '0rem' }}

	*/

	module.exports = exports['default'];

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(3);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _gatsbyImage = __webpack_require__(27);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _SEO = __webpack_require__(41);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Container = __webpack_require__(9);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _Content = __webpack_require__(69);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Suggestions = __webpack_require__(76);
	
	var _Suggestions2 = _interopRequireDefault(_Suggestions);
	
	var _WaveNews = __webpack_require__(79);
	
	var _WaveNews2 = _interopRequireDefault(_WaveNews);
	
	var _Card = __webpack_require__(66);
	
	var _Button = __webpack_require__(39);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Footer = __webpack_require__(12);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Line = __webpack_require__(101);
	
	var _Line2 = _interopRequireDefault(_Line);
	
	var _LinePad = __webpack_require__(40);
	
	var _LinePad2 = _interopRequireDefault(_LinePad);
	
	var _website = __webpack_require__(8);
	
	var _website2 = _interopRequireDefault(_website);
	
	var _SlideUp = __webpack_require__(5);
	
	var _SlideUp2 = _interopRequireDefault(_SlideUp);
	
	var _Browser = __webpack_require__(6);
	
	var _Browser2 = _interopRequireDefault(_Browser);
	
	__webpack_require__(92);
	
	var _reactDisqusComments = __webpack_require__(38);
	
	var _reactDisqusComments2 = _interopRequireDefault(_reactDisqusComments);
	
	var _DisqusContainer = __webpack_require__(70);
	
	var _DisqusContainer2 = _interopRequireDefault(_DisqusContainer);
	
	var _Trophy = __webpack_require__(44);
	
	var _Trophy2 = _interopRequireDefault(_Trophy);
	
	var _DraftingCompass = __webpack_require__(82);
	
	var _DraftingCompass2 = _interopRequireDefault(_DraftingCompass);
	
	var _CenterGrid = __webpack_require__(99);
	
	var _CenterGrid2 = _interopRequireDefault(_CenterGrid);
	
	var _SubNav = __webpack_require__(50);
	
	var _SubNav2 = _interopRequireDefault(_SubNav);
	
	var _FillBg = __webpack_require__(16);
	
	var _FillBg2 = _interopRequireDefault(_FillBg);
	
	var _FxVignette = __webpack_require__(22);
	
	var _FxVignette2 = _interopRequireDefault(_FxVignette);
	
	var _FxTint = __webpack_require__(73);
	
	var _FxTint2 = _interopRequireDefault(_FxTint);
	
	var _ZoomPanWrap = __webpack_require__(80);
	
	var _ZoomPanWrap2 = _interopRequireDefault(_ZoomPanWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint max-len: 0 */
	/* eslint react/no-unescaped-entities: 0 */
	
	var IconSpan = /*#__PURE__*/(0, _reactEmotion2.default)("span", {
	  target: "eizxpo00"
	})("top:0.17rem;left:-0.25rem;position:relative;");
	
	var CompassIconSpan = /*#__PURE__*/(0, _reactEmotion2.default)("span", {
	  target: "eizxpo01"
	})("top:-0.75rem;position:relative;");
	
	var FooterDiv = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eizxpo02"
	})("text-align:center;color:", function (props) {
	  return props.theme.colors.pure.bright;
	}, ";h1{color:", function (props) {
	  return props.theme.colors.pure.bright;
	}, ";text-shadow:", function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ";}@media (max-width:", function (props) {
	  return props.theme.breakpoints.s;
	}, "){top:-250px;}");
	
	var Hero = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eizxpo03"
	})("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000;color:", function (props) {
	  return props.theme.colors.pure.bright;
	}, ";display:flex;flex-direction:column;width:100%;max-width:", function (props) {
	  return props.theme.layout.base;
	}, ";padding:0 2rem;text-align:center;");
	
	var CardWrapper = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eizxpo04"
	})("display:flex;flex-direction:row;flex-wrap:wrap;justify-Content:space-between;padding-left:2rem;padding-right:2rem;margin-bottom:2rem;font-family:", function (props) {
	  return props.theme.fontFamily.button;
	}, ";text-shadow:1px 0px 0 ", function (props) {
	  return props.theme.colors.cool.dark;
	}, ",0px 1px 0 ", function (props) {
	  return props.theme.colors.cool.dark;
	}, ",1px 1px 0 ", function (props) {
	  return props.theme.colors.cool.dark;
	}, ";", _Card.Card, "{color:", function (props) {
	  return props.theme.set.light.p00;
	}, ";h2{color:", function (props) {
	  return props.theme.set.light.h1;
	}, ";text-shadow:", function (props) {
	  return props.theme.set.light.shadow._3dThin;
	}, ";}margin-bottom:2rem;text-align:center;flex-basis:calc(33.3% - 1rem);max-width:calc(33.3% - 1rem);width:calc(33.3% - 1rem);/*\n    flex-basis:calc(99.9% * 1 / 3 - 1rem);max-width:calc(99.9% * 1 / 3 - 1rem);width:calc(99.9% * 1 / 3 - 1rem);*/\n   font-size:1.25rem;h2{position:relative;margin-bottom:0.25rem;}@media (max-width:1000px){font-size:1rem;}@media (max-width:750px){flex-basis:100%;max-width:100%;width:100%;margin-bottom:1.5rem;}}");
	
	var TrophyDiv = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eizxpo05"
	})("positon:absolute;display:inline-block;width:2rem;height:2rem;margin-right:0.85rem;padding-bottom:2.5rem;transform:translateY(0.1225px);svg{g{fill:", function (props) {
	  return props.theme.colors.pure.white;
	}, ";stroke-width:24;}}");
	
	var TitleH2 = /*#__PURE__*/(0, _reactEmotion2.default)("h2", {
	  target: "eizxpo06"
	})("font-size:2.95rem;color:", function (props) {
	  return props.theme.colors.pure.bright;
	}, ";text-shadow:", function (props) {
	  return props.theme.set.light.shadow._3d;
	}, ";");
	
	var SlideUp00 = /*#__PURE__*/(0, _reactEmotion2.default)("div", {
	  target: "eizxpo07"
	})();
	
	var Product = function Product(_ref) {
	  var _ref$pathContext = _ref.pathContext,
	      slug = _ref$pathContext.slug,
	      left = _ref$pathContext.left,
	      right = _ref$pathContext.right,
	      postNode = _ref.data.markdownRemark,
	      location = _ref.location;
	
	  var post = postNode.frontmatter;
	  post.cover.childImageSharp.dutone = {
	    highlight: "#465182",
	    shadow: "#465182"
	  };
	  var sizes = post.cover.childImageSharp.sizes;
	
	  if (!post.id) {
	    post.id = slug;
	  }
	
	  _gatsbyImage2.default.sizes = sizes;
	
	  // ---------------------------------------------------------------
	  // Disqus
	  // ---------------------------------------------------------------
	  var disqus = {
	    shortname: "sondro",
	    url: "" + location.hostname + post.title,
	    identifier: location.pathname,
	    title: post.title.text,
	    language: "en"
	  };
	  // ---------------------------------------------------------------
	  /*
	  <div style={{ position: "relative", zIndex: "9", top: "8.5rem" }}>
	          <SlideUp delay={51} fromOpacity={1} fromY='100px'>
	            <WaveNews />
	          </SlideUp>
	        </div>
	  */
	  if ((0, _Browser2.default)() === 'chrome') {
	    SlideUp00 = _SlideUp2.default;
	  }
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, { title: post.title + " | " + _website2.default.siteTitle }),
	    _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	    _react2.default.createElement(
	      _ZoomPanWrap2.default,
	      null,
	      _react2.default.createElement(
	        Hero,
	        null,
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 25, fromY: "0px", fromX: "32px" },
	          _react2.default.createElement(
	            TitleH2,
	            null,
	            "\xA0" + "." + "\xA0" + ":" + "\xA0" + post.title + "\xA0" + ":" + "\xA0" + "."
	          )
	        )
	      ),
	      _react2.default.createElement(_FxVignette2.default, null),
	      _react2.default.createElement(_FxTint2.default, null),
	      _react2.default.createElement(_WaveNews2.default, null),
	      _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes })
	    ),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        _FillBg2.default,
	        null,
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 250, fromY: "0px" },
	          _react2.default.createElement(
	            _SubNav2.default,
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/design" },
	              _react2.default.createElement(
	                CompassIconSpan,
	                null,
	                _react2.default.createElement(_DraftingCompass2.default, null)
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\xA0" + ":" + "\xA0" + "DESIGN"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          SlideUp00,
	          { delay: 100, fromY: "12px" },
	          _react2.default.createElement(
	            CardWrapper,
	            null,
	            _react2.default.createElement(
	              _Card.Card,
	              null,
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Brand / IP"
	              ),
	              post.brand
	            ),
	            _react2.default.createElement(
	              _Card.Card,
	              null,
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Tech"
	              ),
	              post.tech
	            ),
	            _react2.default.createElement(
	              _Card.Card,
	              null,
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Span"
	              ),
	              post.time
	            )
	          ),
	          _react2.default.createElement(
	            _Container2.default,
	            null,
	            _react2.default.createElement(_Content2.default, { input: postNode.html }),
	            _react2.default.createElement(
	              _DisqusContainer2.default,
	              { type: "article" },
	              _react2.default.createElement(_Line2.default, null),
	              _react2.default.createElement(_reactDisqusComments2.default, {
	                shortname: disqus.shortname,
	                identifier: disqus.identifier
	                // url={disqus.url}
	                , title: disqus.title,
	                language: disqus.language
	              })
	            )
	          ),
	          _react2.default.createElement(
	            SlideUp00,
	            { fromY: "0px", fromX: "90px", delay: 1400 },
	            _react2.default.createElement(_LinePad2.default, null)
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            _CenterGrid2.default,
	            null,
	            _react2.default.createElement(
	              _SubNav2.default,
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: "/product" },
	                _react2.default.createElement(
	                  IconSpan,
	                  null,
	                  _react2.default.createElement(_Trophy2.default, null)
	                ),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "\xA0" + ":" + "\xA0" + "PRODUCT"
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Container2.default,
	            null,
	            _react2.default.createElement(_Suggestions2.default, { left: left, right: right }),
	            _react2.default.createElement("div", { style: { padding: "2.6823rem" } })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Footer2.default,
	      null,
	      _react2.default.createElement(
	        FooterDiv,
	        null,
	        _react2.default.createElement(
	          "h1",
	          null,
	          "Launch Your Dream!"
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/help" },
	          _react2.default.createElement(
	            _Button2.default,
	            { type: "main" },
	            _react2.default.createElement("div", { style: { height: "0.25rem" } }),
	            _react2.default.createElement(
	              TrophyDiv,
	              null,
	              _react2.default.createElement(_Trophy2.default, null)
	            ),
	            ":" + "\xA0" + ":" + "\xA0" + "New" + "\xA0" + "Product" + "\xA0" + ":" + "\xA0" + ":"
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Product;
	
	
	Product.propTypes = {
	  pathContext: _propTypes2.default.shape({
	    slug: _propTypes2.default.string.isRequired
	  }),
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.object.isRequired
	  })
	};
	
	/* eslint no-undef: "off" */
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	// duotone: { highlight: "#465182", shadow: "#20253c" }
	
	//"#b69659"
	//highlight: "#5ABDFF", shadow: "#3466DB"

/***/ }),

/***/ 92:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-jsx-45baba761252024df54d.js